import axios from 'axios';
import { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import login from '../assets/5494204.webp';
import Footer from './Footer';
import Header from './Header';


const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMsg('');
    setSuccessMsg('');

    try {
      const response = await axios.post('/auth/login', {
        email,
        password,
      });

      const { token, message, user } = response.data;

      sessionStorage.setItem('token', token);
      sessionStorage.setItem('driver_id', user.accountNumber || '');
      sessionStorage.setItem('userEmail', user.email);
      sessionStorage.setItem('userType', user.userType);
      sessionStorage.setItem('customer_id', user.accountNumber);
      sessionStorage.setItem('customer_name', user.first_name);
      sessionStorage.setItem('l_name', user.last_name);
      sessionStorage.setItem('customer_phone', user.phone);
      sessionStorage.setItem('customer_address', user.address);
      sessionStorage.setItem('payment_method', user.payment_method);
      sessionStorage.setItem('payment_frequency', user.paymentFrequency);
      sessionStorage.setItem('paypal_email', user.paymentContact);
      sessionStorage.setItem('ach_account_name', user.ach_account_name);
      sessionStorage.setItem('ach_account_number', user.ach_routing_number);
      sessionStorage.setItem('ach_account_type', user.ach_account_type);
      sessionStorage.setItem('ach_routing_number', user.ach_routing_number);
      sessionStorage.setItem('stripe_account_id', user.stripe_account_id);
      sessionStorage.setItem('Country', user.country);
      sessionStorage.setItem('State', user.state);
      sessionStorage.setItem('City', user.city);
      sessionStorage.setItem('Zip', user.zip);
      sessionStorage.setItem('Borough', user.borough);


      setSuccessMsg(message);

      // Redirection
      setTimeout(() => {
        if (user.userType === 'driver') {
          navigate('/driver', { replace: true });
        } else {
          navigate('/account', { replace: true });
        }
      }, 1000);
    } catch (error) {
      console.error(error);
      if (error.response) {
        setErrorMsg(error.response.data.message || 'Login failed');
      } else {
        setErrorMsg('Network error');
      }
    }
  };



  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-b from-[#f7fff0] to-[#ecffdc]">
      <Header />
      <main className="flex-grow flex items-center justify-center px-4 py-8">
        <div className="rounded-3xl shadow-xl max-w-3xl w-full flex flex-col md:flex-row items-center p-4 md:p-8 bg-[#9cc026] bg-opacity-40">
          <div className="w-full md:w-1/2 flex justify-center md:mb-0">
            <img src={login} alt="Illustration" className="w-full h-auto" />
          </div>
          <div className="w-full px-4 md:px-8">
            <h1 className="text-3xl font-semibold text-center md:text-left text-[#9cc026] mb-2">Customer / Driver Login</h1>
            <p className="text-sm text-left mb-4">
              Don't have an account? <Link to="/register" className="text-[#1E98D7]">Sign Up</Link>
            </p>
            {errorMsg && (
              <div className="mb-4 flex items-center gap-2 rounded-md bg-red-100 border border-red-400 text-red-700 px-4 py-3 text-sm">
                <svg className="w-5 h-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-5.75a.75.75 0 011.5 0v.5a.75.75 0 01-1.5 0v-.5zM10 6a.75.75 0 01.743.648l.007.102v4a.75.75 0 01-1.493.102L9.25 10.75V6.75A.75.75 0 0110 6z"
                    clipRule="evenodd"
                  />
                </svg>
                {errorMsg}
              </div>
            )}

            {successMsg && (
              <div className="mb-4 flex items-center gap-2 rounded-md bg-green-100 border border-green-400 text-green-700 px-4 py-3 text-sm">
                <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 6.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l7-7a1 1 0 000-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
                {successMsg}
              </div>
            )}

            <form className="space-y-4" onSubmit={handleLogin}>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter Email"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#9cc026]"
              />
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter Password"
                  className="w-full px-4 py-2 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#9cc026]"
                />
                <div
                  className="absolute inset-y-0 right-3 flex items-center cursor-pointer"
                  onClick={() => setShowPassword((prev) => !prev)}
                >
                  {showPassword ? (
                    <FaEyeSlash className="text-gray-600" />
                  ) : (
                    <FaEye className="text-gray-600" />
                  )}
                </div>
              </div>
              <button
                type="submit"
                className="w-full bg-green-600 hover:bg-[#08a905] text-white py-2 rounded-md transition"
              >
                Login
              </button>
            </form>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default LoginPage;
